import {Application} from "@/models/Application"
import {List} from "@/models/List"

export class ProtocolLineDtoList extends List{
  constructor(obj) {
    super(ProtocolLineDto, obj)
  }
}

export class ProtocolLineDto {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.fullName = obj?.fullName || null
    this.testScore = obj?.testScore || null
    this.courseNumberTo = obj?.courseNumberTo || null
    this.paidFormTo = obj?.paidFormTo || null
    this.specialityTo = obj?.specialityTo || null
    this.decision = obj?.decision || null
    this.applicationType = obj?.applicationType || null
  }
}